module.exports = __webpack_public_path__ + "7m8l7TlFO-S3VkhHuR0at4gp9Q8gbYrhqGlRav_IXfk.6ca04d49437986fdaf65.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/7m8l7TlFO-S3VkhHuR0at4gp9Q8gbYrhqGlRav_IXfk.woff2
// module id = ../../../../../src/assets/fonts/font-google/7m8l7TlFO-S3VkhHuR0at4gp9Q8gbYrhqGlRav_IXfk.woff2
// module chunks = 40